import { NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { buildNavItems } from "@/lib/navItems";

// App-style bottom tab bar, mobile only (<md).
//
// 2026-02-09 — rewritten to consume the shared ``buildNavItems`` registry so
// sales_manager / gt_export / production_manager / market_surveyor no longer
// see an empty bar on iPhone Safari. Shows the first 3 role-appropriate tabs
// plus a "More" button that opens the full hamburger drawer.
export function MobileTabBar({ onOpenMore }) {
  const { user } = useAuth();
  const { t } = useLanguage();
  const role = user?.role;

  const allTabs = buildNavItems(role, t);
  // 2026-06 · 采购 / 采购经理 手机端主要就用「采购报价」+「报价单」，把这两个顶到前面。
  const PRIORITY = ["buyer", "procurement_manager"].includes(role)
    ? ["/procurement-quotes", "/quotes"]
    // 2026-06 · 外销手机端主用「报价单」，其次产品 / 客户。
    : ["export", "gt_export"].includes(role)
      ? ["/quotes", "/", "/customers"] : [];
  const ordered = [
    ...PRIORITY.map((to) => allTabs.find((i) => i.to === to)).filter(Boolean),
    ...allTabs.filter((i) => !PRIORITY.includes(i.to)),
  ];
  // Show up to 3 primary tabs so labels stay readable + room for "More".
  const primary = ordered.slice(0, 3).map((item, i) => ({
    ...item,
    // Only the Products tab needs ``end`` because it lives at "/".
    end: item.to === "/",
    testId: `mobile-tab-${item.testId?.replace(/^nav-/, "") || i}`,
  }));

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-border flex pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-tab-bar"
    >
      {primary.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          data-testid={tab.testId}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium transition-colors ${
              isActive ? "text-brand" : "text-muted-foreground"
            }`
          }
        >
          <tab.icon size={20} />
          <span className="truncate max-w-[64px]">{tab.label}</span>
        </NavLink>
      ))}
      {ordered.length > 3 && (
        <button
          type="button"
          onClick={onOpenMore}
          data-testid="mobile-tab-more"
          className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium text-muted-foreground hover:text-brand transition-colors"
        >
          <Menu size={20} />
          <span className="truncate max-w-[64px]">{t("nav.more") || "更多"}</span>
        </button>
      )}
    </nav>
  );
}
